/* eslint-disable react/prop-types */
import classNames from 'classnames';
import * as React from 'react';

import styles from './loader-sm.module.css';
import stylesXs from './loader-xs.module.css';

export const LoaderSm = ({
  className,
  ...otherProps
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div
      className={classNames({ [styles.loader]: true, [className || '']: !!className })}
      {...otherProps}
    >
      <span>Loader</span>
    </div>
  );
};

export const LoaderXs = ({
  className,
  ...otherProps
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div
      className={classNames({ [stylesXs.loaderxs]: true, [className || '']: !!className })}
      {...otherProps}
    >
      <span></span>
    </div>
  );
};
